import { render, staticRenderFns } from "./BackgroundJob.vue?vue&type=template&id=4545d59e&scoped=true"
import script from "./BackgroundJob.vue?vue&type=script&lang=js"
export * from "./BackgroundJob.vue?vue&type=script&lang=js"
import style0 from "./BackgroundJob.vue?vue&type=style&index=0&id=4545d59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4545d59e",
  null
  
)

export default component.exports